import { Action } from "redux";

export type ExplorerModeSwitchedEvent = Action<typeof EXPLORER_MODE_SWITCHED>

// Marks a mode change as the user's own, made from the Explorer's toggle, rather than one arriving
// with a saved view. It carries no mode: inspectionModeSelected goes out alongside it and stays
// the event everything else listens to.
const explorerModeSwitched = (): ExplorerModeSwitchedEvent => ({
  type: EXPLORER_MODE_SWITCHED
});

export const EXPLORER_MODE_SWITCHED = "explorer_mode_switched";

export default explorerModeSwitched;
